"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.USER_ID_HEADER = exports.TRACE_ID_HEADER = exports.TOGGLE_OVERRIDE_HEADER = exports.SOURCE_HEADER = exports.DEALER_TOGGLE_OVERRIDE_HEADER = exports.DEALER_ID_HEADER = exports.CORRELATION_ID_HEADER = void 0;
exports.CORRELATION_ID_HEADER = 'x-coxauto-correlation-id';
exports.DEALER_ID_HEADER = 'x-dr-dealer-id';
exports.DEALER_TOGGLE_OVERRIDE_HEADER = 'x-dr-dealer-toggle-override';
exports.SOURCE_HEADER = 'x-dr-source';
exports.TOGGLE_OVERRIDE_HEADER = 'x-dr-toggle-override';
exports.TRACE_ID_HEADER = 'x-dr-trace-id';
exports.USER_ID_HEADER = 'x-dr-user-id';
